<template>
  <v-layout>
    <v-tabs vertical class="my-tabs" v-model="active_tab">
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៥.ក ៥.ខ
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៥.គ.ឃ.ង
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៥.ច ៥.ឆ​
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៥.ជ ៥.ឈ,ញ,ដ
      </v-tab>
      <v-tab-item>
        <div class="row">
          <div>
            <emisbuilding :data="fac_5bn" :title="title[10]" :lastacc="lst_acc"/>
          </div>
          <div class="row">            
            <div><schoolroom :data="fac_5cc"/></div>
            <div><roomfac :data="fac_5cn" :title="title[11]"/></div>
            <!-- No title on the form -->
          </div>          
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <schoolarea :data="fac_5a" :last_row="0" :title="title[12]" />
            <preextoy :data="uti_5d" :title="title[13]" />
          </div>
          <div>
            <handwashing :data="uti_5e" :lastRow="0" :title="title[14]" />
            <!-- LastRow is 0 for pre school only -->
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <toilet :data="uti_5f" :title="title[15]" />
          </div>
          <div>
            <water :data="uti_5g" :title="title[16]" />
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div>
          <div>
            <facility :data1="uti_5h1" :data2="uti_5h2" :title="title[17]" />
          </div>
          <div>
            <giga :data="giga" :title="title[18]"/>
          </div>
          <div>
            <schdormitory :data="edbt" :title="title[19]"/>
          </div>
          <div>
            <schbudinternet :data="idbt" :title="title[20]"/>
          </div>
        </div>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>

<script>
import preExternalToy from "@/components/ascf/pre/preExternalToy.vue";
import schoolArea from "@/components/ascf/sharedCom/schoolArea.vue";
import schoolRoom from "@/components/ascf/sharedCom/schoolRoom.vue";
import handWashing from "@/components/ascf/sharedCom/handwashing.vue";
import toilet from "@/components/ascf/sharedCom/toilet.vue";
import Facility from "@/components/ascf/sharedCom/facility.vue";
import WaterSource from "@/components/ascf/sharedCom/waterSource.vue";
import emis_building from "@/components/ascf/sharedCom/emis_building.vue";
import roomfac from "@/components/ascf/sharedCom/emis_facilities.vue";
import giga from "@/components/ascf/sharedCom/giga.vue";
import schDormitory from "@/components/ascf/sharedCom/schDormitory.vue";
import schBudInternet from "@/components/ascf/sharedCom/schBudInternet.vue";

export default {
  props: [
    "title",
    "fac_5a",
    "fac_5b",
    "fac_5bn",
    "fac_5c",
    "fac_5cn",
    "fac_5cc",
    "uti_5d",
    "uti_5e",
    "uti_5f",
    "uti_5g",
    "uti_5h1",
    "uti_5h2",
    "giga",
    "edbt",
    "idbt",
    "lst_acc",
  ],
  components: {
    preextoy: preExternalToy,
    schoolarea: schoolArea,
    schoolroom: schoolRoom,
    handwashing: handWashing,
    toilet: toilet,
    facility: Facility,
    water: WaterSource,
    emisbuilding: emis_building,
    roomfac: roomfac,
    giga: giga,
    schdormitory: schDormitory,
    schbudinternet: schBudInternet
  },
  data() {
    return {
      active_tab: 0,
    };
  },
  methods: {},
};
</script>
<style scoped>
.row {
  display: flex;
}
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
  font-weight: bold;
}
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
</style>